export default "__VITE_ASSET__DNL_f6AR__"